"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIconWrapper = exports.StyledIconLabel = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledIconLabel = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  ", "\n"])), function (_a) {
    var alignCentre = _a.alignCentre;
    return "\n    ".concat(alignCentre ? 'justify-content: center;' : '', "\n  ");
});
exports.StyledIconWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var _b = _a.theme, space = _b.space, mediaQueries = _b.mediaQueries, inline = _a.inline;
    return "\n    display: ".concat(inline ? 'inline' : 'block', ";\n    margin-right: ").concat(space[2], ";\n    line-height: 0;\n    width: ").concat(space[4], ";\n\n    ").concat(mediaQueries.mediumAndUp, " {\n      width: auto;\n    }\n\n    svg {\n      max-height: 32px; /* IE11 SVG height bug fix */\n    }\n  ");
});
var templateObject_1, templateObject_2;
